import React, { ReactElement } from 'react';
import { Grid, Container } from '@mui/material';
import { ContentData } from 'model/ContentData';
import ContentCard from './ContentCard';
import globalClasses from 'containers/Layouts/Layout.module.css';
import _ from 'classnames';
import { ContentSectionType } from 'model/enums';
import { FormattedMessage } from 'react-intl';
import i18n from 'i18n/I18nInstance';

interface IProps {
    contentCards: ContentData[];
    sectionType?: ContentSectionType;
    disablePrint: boolean;
    disablePrintMobileOnly: boolean;
}

export default function ContentSection(props: IProps): ReactElement {
    const displayDoneThumb = (): ReactElement => {
        const i18n_allViewed = i18n.translator.formatMessage({
            id: 'contentSection.AllViewed',
            defaultMessage: 'All Viewed',
        });

        return (
            <div>
                <div className={globalClasses.doneSectionImg}>
                    <img data-qaid="sectionImg" src="./img/all-ok.svg" alt={i18n_allViewed}></img>
                </div>
                <Container style={{ paddingRight: 16, paddingLeft: 16 }}>
                    <div
                        data-qaid="sectionText"
                        className={_(
                            globalClasses.typography_body1,
                            globalClasses.doneSectionText,
                            globalClasses.centeredText,
                        )}
                    >
                        <FormattedMessage
                            id="contentSection.UpToDate"
                            defaultMessage="You are up to date with your resources. You've seen all new posts."
                        />
                    </div>
                </Container>
            </div>
        );
    };

    const displayCards = (): ReactElement => {
        const isMobile = () => {
            const UA = navigator.userAgent;
            // Test for Mobi in the user agent. Recommended by mozilla, here:
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
            return /Mobi/g.test(UA);
        };

        const disablePrint = props.disablePrint || (isMobile() && props.disablePrintMobileOnly);

        return (
            <div
                style={{ margin: '32px 24px' }}
                role="feed"
                data-qaid={
                    props.sectionType === ContentSectionType.NotViewed
                        ? 'nonViewedSection'
                        : 'viewedSection'
                }
            >
                <Grid container spacing={3}>
                    {props.contentCards
                        .sort((a: ContentData, b: ContentData) => {
                            const aDate = a && a.date ? a.date.getTime() : 0;
                            const bDate = b && b.date ? b.date.getTime() : 0;
                            return bDate - aDate;
                        })
                        .map((data: ContentData, key: number) => {
                            if (
                                (props.sectionType === ContentSectionType.NotViewed &&
                                    !data.recalled) ||
                                props.sectionType === ContentSectionType.Viewed
                            ) {
                                return (
                                    <Grid item xs={12} md={6} lg={4} xl={3} key={key}>
                                        <ContentCard
                                            contentData={data}
                                            hideActions={disablePrint}
                                        />
                                    </Grid>
                                );
                            }
                            return null;
                        })}
                </Grid>
            </div>
        );
    };

    return (
        <React.Fragment>
            {props.contentCards.length === 0 && props.sectionType === ContentSectionType.NotViewed
                ? displayDoneThumb()
                : displayCards()}
        </React.Fragment>
    );
}
